import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    standingOrders: [],
    standingInstructionFrequency: [],
    standingInstructionSchedule: [],
};
const mutations = {
    // set the standing orders
    SET_STANDING_ORDERS(state, standingOrders) {
        state.standingOrders = standingOrders;
    },
    // set the standing instruction frequency
    SET_STANDING_INSTRUCTION_FREQUENCY(state, standingInstructionFrequency) {
        state.standingInstructionFrequency = standingInstructionFrequency;
    },
    // set the standing instruction schedule
    SET_STANDING_INSTRUCTION_SCHEDULE(state, standingInstructionSchedule) {
        state.standingInstructionSchedule = standingInstructionSchedule;
    },
};
const actions = {
    // get standing orders
    async getStandingOrders({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/StandingInstruction?PageIndex=0&PageSize=100`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_STANDING_ORDERS', userParseData);
            }
        }
    },
    // stop standing order
    async stopStandingOrder({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/StandingInstruction/StopInstruction`, encryptedData, { headers });
            return response;
        }
    },
    // get standing instruction frequency
    async getStandingInstructionFrequency({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Enum/getStandingInstructionFrequency`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_STANDING_INSTRUCTION_FREQUENCY', userParseData);
            }
        }
    },
    // stop schedule
    async stopSchedule({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/StandingInstruction/StopSchedule`, encryptedData, { headers });
            return response;
        }
    },
    // generate schedule
    async generateSchedule({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/StandingInstruction/GenerateSchedule`, encryptedData, { headers });
            return response;
        }
    },
    // submit standing order
    async submitStandingOrder({ }, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/StandingInstruction/Create`, encryptedData, { headers });
            return response;
        }
    },
    // get standing instruction schedule
    async getStandingInstructionSchedule({ commit }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/StandingInstruction/GetInstructionSchedule/${data}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_STANDING_INSTRUCTION_SCHEDULE', userParseData);
            }
        }
    }
    
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};